module.exports = __webpack_public_path__ + "img/lion-white.bc4c1567.png";